export const getUserId = appState => {
  const {
    auth,
    view
  } = appState;
  const currentUserId = auth.user && auth.user.user_id;
  const presentationUserId = view.presentation.presentation && view.presentation.presentation.userId;
  return currentUserId || presentationUserId || null;
};